<template>
  <div id="app">
    <router-view class="default"></router-view>
    <router-view class="header" name="header"></router-view>
     <router-view name="hero"></router-view>
     <router-view class="container-fluid" name="what"></router-view>
     <router-view class="container-fluid" name="why"></router-view>
<!--      <router-view class="container-fluid" name="index"></router-view> -->
     <router-view class="container-fluid" name="clients"></router-view>
     <router-view class="container-fluid" name="how"></router-view>
    <router-view class="container-fluid" name="contact"></router-view>
    <router-view class="container-fluid" name="footer"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>

@font-face {
    font-family: 'ObjektivMk3';
    src: url("/static/fonts/ObjektivMk3_W_Rg.eot");
    src: url("/static/fonts/ObjektivMk3_W_Rg.eot?#iefix") format("embedded-opentype"), url("/static/fonts/ObjektivMk3_W_Rg.woff2") format("woff2"), url("/static/fonts/ObjektivMk3_W_Rg.woff") format("woff");
    font-weight: 400;
    font-style: normal
}
@font-face {
    font-family: 'ObjektivMk3';
    src: url("/static/fonts/ObjektivMk3_W_Md.eot");
    src: url("/static/fonts/ObjektivMk3_W_Md.eot?#iefix") format("embedded-opentype"), url("/static/fonts/ObjektivMk3_W_Md.woff2") format("woff2"), url("/static/fonts/ObjektivMk3_W_Md.woff") format("woff");
    font-weight: 500;
    font-style: normal
}

      @font-face {
        font-family: 'ClanOT-News';
        font-weight: normal;
        src: url("/static/fonts/ClanOT-News.woff") format("woff");
      }

      @font-face {
        font-family: 'ClanWebPro';
        font-weight: normal;
        src: url("/static/fonts/ClanWebPro-Book.woff") format("woff");
      }

      @font-face {
        font-family: 'ClanWebPro';
        font-weight: bold;
        src: url("/static/fonts/ClanWebPro-Medium.woff") format("woff");
      }

      @font-face {
        font-family: 'ClanOT-ExtdNews';
        src: url('/static/fonts/ClanOT-ExtdNews.eot');
        src: local('☺'), url('/static/fonts/ClanOT-ExtdNews.woff') format('woff'), url('/static/fonts/ClanOT-ExtdNews.ttf') format('truetype'), url('/static/fonts/ClanOT-ExtdNews.svg') format('svg');
        font-weight: normal;
        font-style: normal;
       }

       @font-face {
        font-family: 'ClanOT-ExtdBook';
        src: url('/static/fonts/ClanOT-ExtdBook.eot');
        src: local('☺'), url('/static/fonts/ClanOT-ExtdBook.woff') format('woff'), url('/static/fonts/ClanOT-ExtdBook.ttf') format('truetype'), url('/static/fonts/ClanOT-ExtdBook.svg') format('svg');
        font-weight: normal;
        font-style: normal;
}


.sys-ops-fo {
  font-family: 'ClanOT-ExtdNews';
  text-transform: lowercase !important;
}

.colchagua-special-font {
  font-family: 'Signerica Fat';
}

body { background-color:#16181c !important; font-family: 'ClanOT-News', -apple-system, ".SFNSText-Regular", "San Francisco", "Roboto", "Segoe UI", "Helvetica Neue", "Lucida Grande", sans-serif;}

#app {
  font-family: 'ClanWebPro', -apple-system, ".SFNSText-Regular", "San Francisco", "Roboto", "Segoe UI", "Helvetica Neue", "Lucida Grande", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-top:calc(58px + 40px);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: lighter;
  margin: 0px;
  line-height: 1.5; }

h1 { font-size: 4rem !important; }
@media all and (max-width: 1199px) { h1 { font-size: 4rem !important; } }
@media all and (max-width: 991px) { h1 { font-size: 3.6rem !important; } }
@media all and (max-width: 768px) { h1 { font-size: 2.8rem !important; } }

h2 { font-size: 3rem !important; }
@media all and (max-width: 1199px) { h2 { font-size: 3rem !important; } }
@media all and (max-width: 991px) { h2 { font-size: 2.7rem !important; } }
@media all and (max-width: 768px) { h2 { font-size: 2.43rem; } }

h3 { font-size: 2rem !important; }
@media all and (max-width: 1199px) { h3 { font-size: 2rem !important; } }
@media all and (max-width: 991px) { h3 { font-size: 1.8rem !important; } }
@media all and (max-width: 768px) { h3 { font-size: 1.4rem !important; } }

h4 { font-size: 1.6rem !important; }
@media all and (max-width: 1199px) { h4 { font-size: 1.6rem !important; } }
@media all and (max-width: 991px) { h4 { font-size: 1.44rem !important; } }
@media all and (max-width: 768px) { h4 { font-size: 1.296rem !important; } }

h5 { font-size: 1.2rem !important; }
@media all and (max-width: 1199px) { h5 { font-size: 1.2rem !important; } }
@media all and (max-width: 991px) { h5 { font-size: 1.08rem !important; } }
@media all and (max-width: 768px) { h5 { font-size: 0.972rem !important; } }

h6 { font-size: 1rem !important; }
@media all and (max-width: 1199px) { h6 { font-size: 1rem !important; } }
@media all and (max-width: 991px) { h6 { font-size: 0.9rem !important; } }
@media all and (max-width: 768px) { h6 { font-size: 0.81rem !important; } }

p { font-size: 0.9rem !important; margin:0; }
@media all and (max-width: 1199px) { p { font-size: 0.9rem !important; } }
@media all and (max-width: 991px) { p { font-size: 0.81rem !important; } }
@media all and (max-width: 768px) { p { font-size: 0.729rem !important; } }

ul {
  padding: 0;
  margin: 0;
  list-style: none; }

a {
  -webkit-transition: all 0.2s ease-in-out 0s;
  -moz-transition: all 0.2s ease-in-out 0s;
  -o-transition: all 0.2s ease-in-out 0s;
  transition: all 0.2s ease-in-out 0s; }

.mt-100 {
  margin-top: 100px; }

a:focus,
.btn:focus,
.btn:active:focus {
  box-shadow: none;
  outline: 0 none; }

a,
a:active,
a:focus,
a:active {
  text-decoration: none; }

.section {
  padding: 100px 0; }

.text-center {
  text-align: center; }

.heading {
  text-align: center;
  color: white;
  padding-bottom: 70px; }
  .heading h1, .heading h2, .heading h3 {
    color: white;
    padding-bottom: 15px;
    font-weight: bold;
    letter-spacing: 2px;
    text-transform: lowercase;
    line-height:2;
    font-family: 'ClanOT-ExtdNews';
    font-weight: normal;
     }
  .heading p {
    font-size: 17px;
    line-height: 24px;
    font-weight: 300; }
  .heading .legend {
    font-weight: lighter;
    margin-top: 2em;
    line-height: 1.8;
  }
  .heading strong {
    padding-bottom: 12px;
  }
  .heading strong.color-1 {
    border-bottom: 3px solid #f39005;
  }
  .heading strong.color-2 {
    border-bottom: 3px solid #f39005;
  }
  .heading strong.color-3 {
    border-bottom: 3px solid #171820;
  }

@media all and (max-width: 768px) {

  .heading .legend {
    text-align: justify;
  }

}



.subheading {
  color: #3c3c3c;
  padding-bottom: 15px;
  text-transform: capitalize;
  font-weight: 500;
  font-size: 32px;
  line-height: 45px; }

.btn {
  border-radius: 0; }

.btn-main {
  color: #f39005;
  border-radius: 30px !important;
  font-size: 1em;
  font-weight: lighter;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 15px 40px !important;
  display: inline-block !important;
  background-color: transparent!important;
  border: 1px solid #f39005!important;
/*  -moz-box-shadow: 0 15px 40px rgba(249, 167, 68, 0.5);
  -webkit-box-shadow: 0 15px 40px rgba(249, 167, 68, 0.5);
  box-shadow: 0 15px 40px rgba(249, 167, 68, 0.5);*/
/*  background-image: -moz-linear-gradient(bottom, rgba(255, 239, 206, 0) 0%, rgba(255, 239, 206, 0.25) 100%) !important;
  background-image: -o-linear-gradient(bottom, rgba(255, 239, 206, 0) 0%, rgba(255, 239, 206, 0.25) 100%) !important;
  background-image: -webkit-linear-gradient(bottom, rgba(255, 239, 206, 0) 0%, rgba(255, 239, 206, 0.25) 100%) !important;
  background-image: linear-gradient(bottom, rgba(255, 239, 206, 0) 0%, rgba(255, 239, 206, 0.25) 100%) !important;*/
  }
  .btn-main:hover, .btn-main:focus {
    background-color: #f9a743!important;
    color: #16181c!important; }

  .btn-main:hover .btn-icon, .btn-main:focus .btn-icon {
    fill:#16181c!important;
  }

.btn-main-sm {
  padding: 12px 35px;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold; }


</style>



// WEBPACK FOOTER //
// src/App.vue